import { render, staticRenderFns } from "./points-banners.vue?vue&type=template&id=4bf8d2ae"
import script from "./points-banners.vue?vue&type=script&lang=js"
export * from "./points-banners.vue?vue&type=script&lang=js"
import style0 from "./points-banners.vue?vue&type=style&index=0&id=4bf8d2ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports